module.exports = __webpack_public_path__ + "img/mujer.92c0dd51.png";